import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";
import type { UserNextStepApi } from "@/Modules/Models/Api/User";
import type { UserNextStep } from "@/Modules/Models/Domain/User";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

const UserNextStepTransformer: TransformerExtended<UserNextStep, UserNextStepApi> = {
  ...DefaultTransformerGenerator<UserNextStep, UserNextStepApi>(),

  toDomain(input: UserNextStepApi): UserNextStep {
    return input;
  },
};

export type UserNextStepTransformerType = TransformerExtended<UserNextStep, UserNextStepApi>;

export default UserNextStepTransformer;
